import { useCallback, useMemo, useState } from 'react'

export const usePriceValue = (initialValue: string) => {
  const [value, setValue] = useState(initialValue)
  const validateInput = useCallback((input: string): boolean => {
    // Pattern represents a string starting with 'R' followed by one or more digits, a '.', and exactly two digits.
    const pattern = /^(R?(\d+)?([\.,])?(\d+)?)?$/
    return pattern.test(input)
  }, [])

  const isComplete = useMemo(() => {
    const pattern1 = /^R?\d+\.\d+$/
    const pattern2 = /^R?\d+$/
    return pattern1.test(value) || pattern2.test(value)
  }, [value])

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target
      if (value === '' || validateInput(value)) {
        setValue(value)
      }
    },
    [setValue],
  )
  const parsedValue = useMemo(() => {
    if (validateInput(value)) {
      return parseFloat(value.substring(value.charAt(0) === 'R' ? 1 : 0))
    }
    return null
  }, [validateInput, value])

  return useMemo(
    () => ({
      value,
      setValue,
      onChange,
      validateInput,
      parsedValue,
      isComplete,
    }),
    [value, setValue, onChange, validateInput, parsedValue, isComplete],
  )
}
